import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MaterialTable, { MTableAction } from "material-table";
import DateFnsUtils from "@date-io/date-fns";
import Typography from "@material-ui/core/Typography";
import FileSaver from "file-saver";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import _ from "lodash";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import PrintIcon from "@material-ui/icons/Print";
import { generatePdf } from "../../../dataSource/pil";
import LockScreenLoading from "../../LockScreenLoading/LockScreenLoading";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  DatePicker,
} from "@material-ui/pickers";
import {
  getDPSDetails,
  updateDesignByRef,
  addDeisgnPackageByRef,
  deleteDesignByRef,
} from "../../../dataSource/dps";

// Material-UI Icon
import AddIcon from "@material-ui/icons/Add";
import { dpsDetailFormStyle } from "../../../styles/jss/components/DPS/dpsDetailFormStyle";
const useStyles = makeStyles((theme) => dpsDetailFormStyle(theme));
const DPS = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [progressTitle, setProgressTitle] = useState("");
  const [dpsDetails, setDpsDetails] = useState();

  const addActionRef = React.useRef();

  const fetchDpsDetails = async () => {
    const response = await getDPSDetails();
    setDpsDetails(response.data);
  };
  const [tmpSeq, setTmpSeq] = useState();
  const [tmpType, setTmpType] = useState();
  const [tmpDesignSeq, setTmpDesignSeq] = useState();
  const [addFlag, setAddFlag] = useState(false);
  const [columns, setColumns] = useState([
    {
      title: "",
      field: "internal_action",
      editable: false,
      width: "2%",
      render: (rowData) =>
        rowData && (
          <IconButton
            style={{
              color: "black",
              padding: "2px",
              float: "left",
            }}
            onClick={() => {
              setTmpSeq(
                rowData.type === "design"
                  ? rowData.item_seq
                  : rowData.subitem_seq
              );
              setTmpType(rowData.type);
              setTmpDesignSeq(rowData.dps_design_seq);
              addActionRef.current.click();
            }}
          >
            <AddIcon />
          </IconButton>
        ),
    },
    {
      title: "Design Package",
      field: "item",
      width: "30%",
      render: (rowData) => {
        return rowData.dps_sub_design_seq !== null ? (
          <div style={{ marginLeft: "12px" }}>
            <li>{rowData.item}</li>
          </div>
        ) : (
          `${rowData.rowNo}. ${rowData.item}`
        );
      },
    },
    {
      title: "Original Target Date",
      field: "orginaltargetdate",
      type: "date",
      width: "15%",
    },
    {
      title: "Revised Target Date",
      field: "revisedtargetdate",
      type: "date",
      width: "15%",
    },
    {
      title: "Actual Date",
      field: "actualdate",
      type: "date",
      width: "15%",
    },
    {
      title: "Remarks(Optional)",
      field: "remarks",
      width: "15%",
    },
  ]);
  const generateDPSPdf = async () => {
    setLockScreenLoadingOpen(true);

    let displayString = "";
    for (let i = 0; i < dpsDetails.length; i++) {
      let item =
        dpsDetails[i].subitem_seq == 0
          ? ` <td style="color:black;border:1px solid grey"><p>${dpsDetails[i].rowNo}.${dpsDetails[i].item}</p></td>`
          : `<td style="color:black;border:1px solid grey"><p>&#8226;${dpsDetails[i].item}</p></td>`;

      displayString = displayString.concat(`
      <tr>    
       ${item}   
      <td style="color:black;border:1px solid grey">${
        dpsDetails[i].orginaltargetdate === null
          ? ""
          : moment(dpsDetails[i].orginaltargetdate).format("YYYY/MM/DD")
      }</td>
      <td style="color:black;border:1px solid grey">${
        dpsDetails[i].revisedtargetdate === null
          ? ""
          : moment(dpsDetails[i].revisedtargetdate).format("YYYY/MM/DD")
      }</td>
      <td style="color:black;border:1px solid grey">${
        dpsDetails[i].actualdate === null
          ? ""
          : moment(dpsDetails[i].actualdate).format("YYYY/MM/DD")
      }</td>
      <td style="color:black;border:1px solid grey">${
        dpsDetails[i].remarks === null ? "" : dpsDetails[i].remarks
      }</td>
    </tr>
    `);
    }
    let tableTemplate = `<div style="page-break-after: always;">
       <table style="border-style: solid;border-width:1px;border-color:grey;width: 100%;">
           <thead>
           <tr style="background-color: rgb(238, 238, 238)">
           <th style="width:45%;align:center;color:black"><strong>Items</strong></th>
           <th style="width:10%;align:center;color:black"><strong>Original Target Date</strong></th>
           <th style="width:10%;align:center;color:black"><strong>Revised Target Date</strong></th>
           <th style="width:10%;align:center;color:black"><strong>Actual Date</strong></th>
           <th style="width:25%;align:center;color:black"><strong>Remarks</strong></th>
           </tr>
           </thead>
           <tbody>             
            ${displayString}           
         </tbody>
       </table>
       <br/><br/><br/><br/><br/><br/>
       <div style="display:flex;justify-content:flex-start">
       <div style="width:32%;border-top:1px solid black;text-align:center">
       <h3 style="font-weight:bold;">Endorsed By:Client PD</h3>
       </div>
       &nbsp;&nbsp;
       <div style="width:32%;border-top:1px solid black;text-align:center">
       <h3 style="font-weight:bold;">Endorsed By:Const. PD</h3>
       </div>
       &nbsp;&nbsp;
       <div style="width:32%;border-top:1px solid black;text-align:center">
       <h3 style="font-weight:bold;">Endorsed By:Const. PM</h3>
       </div>
       </div>
       </div>
   `;

    let htmlStr = `
      <html>
        <head>
            <meta charset="utf-8">
            <style>
            @page { margin: 1cm;}     
            @media print{
             
            } 
            
        </style>
        </head>
        <body>
        <div style="font-size: 9px;margin:0;">     
        ${tableTemplate}
          </div>    
        </body>
    </html>
  `;

    const pdf = await generatePdf(htmlStr, "");
    FileSaver.saveAs(
      pdf,
      `Design Package Schedule - ${store.get("site_code")}.pdf`
    );

    setLockScreenLoadingOpen(false);
  };
  useEffect(() => {
    const getDetails = async () => {
      await fetchDpsDetails();
    };
    getDetails();
  }, [addFlag]);

  return (
    <Fragment>
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <Box>
        <AppBar position="static" color="transparent">
          <Toolbar>
            <Typography variant="h6" className={classes.appbarTest}>
              Design Package Schedule
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>
      <Tooltip title="Print PDF">
        <IconButton
          aria-label="add"
          onClick={() => {
            generateDPSPdf();
          }}
        >
          <PrintIcon />
        </IconButton>
      </Tooltip>
      {dpsDetails && (
        <MaterialTable
          data={dpsDetails}
          columns={columns}
          editable={{
            isDeleteHidden: (rowData) => rowData.template === "Y",
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(async () => {
                  const dataUpdate = [...dpsDetails];
                  const index = oldData.tableData.id;
                  dataUpdate[index] = newData;
                  await updateDesignByRef(oldData.type, newData).then((res) => {
                    setDpsDetails([...dataUpdate]);
                    setAddFlag(!addFlag);
                  });
                  resolve();
                }, 1000);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(async () => {
                  const dataDelete = [...dpsDetails];
                  const index = oldData.tableData.id;
                  dataDelete.splice(index, 1);
                  await deleteDesignByRef(oldData.type, oldData).then((res) => {
                    setDpsDetails([...dpsDetails]);
                    setAddFlag(!addFlag);
                  });
                  resolve();
                }, 1000);
              }),
            onRowAdd: (newData) =>
              new Promise((resolve, reject) => {
                setTimeout(async () => {
                  let example = [...dpsDetails];
                  let exampleBody = [...dpsDetails];
                  let exampleData = {};
                  if (tmpType === "design") {
                    exampleData = {
                      flag: "NEW",
                      dps_design_seq: -1,
                      dps_seq: dpsDetails[0].dps_seq,
                      template: "N",
                      dps_sub_design_seq: null,
                      ref: "design",
                      item: newData.item === null ? "" : newData.item,
                      item_seq: Number(tmpSeq) + 1,
                      orginaltargetdate:
                        newData.orginaltargetdate === null
                          ? ""
                          : newData.orginaltargetdate,
                      revisedtargetdate:
                        newData.revisedtargetdate === null
                          ? ""
                          : newData.revisedtargetdate,
                      actualdate:
                        newData.actualdate === null ? "" : newData.actualdate,
                      remarks: newData.remarks,
                    };
                    let index = dpsDetails.findIndex(
                      (obj) =>
                        obj.item_seq == tmpSeq &&
                        obj.dps_design_seq == tmpDesignSeq &&
                        obj.dps_sub_design_seq === null
                    );
                    example.splice(index + 1, 0, exampleData);
                    example = _.union(
                      example
                        .filter(
                          (obj) =>
                            obj.dps_sub_design_seq === null &&
                            (Number(obj.item_seq) <= tmpSeq ||
                              obj.flag === "NEW")
                        )
                        .map((jobj) => {
                          return {
                            dps_seq: jobj.dps_seq,
                            dps_design_seq: jobj.dps_design_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.item_seq),
                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.type,
                          };
                        }),
                      example
                        .filter(
                          (obj) =>
                            Number(obj.item_seq) > tmpSeq &&
                            obj.flag !== "NEW" &&
                            obj.dps_sub_design_seq === null
                        )
                        .map((jobj) => {
                          return {
                            dps_seq: jobj.dps_seq,
                            dps_design_seq: jobj.dps_design_seq,

                            item: jobj.item,
                            item_seq: Number(jobj.item_seq) + 1,

                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.type,
                          };
                        })
                    );
                  } else if (tmpType === "subdesign") {
                    exampleData = {
                      flag: "NEW",
                      dps_seq: dpsDetails[0].dps_seq,
                      dps_design_seq: tmpDesignSeq,
                      dps_sub_design_seq: 0,
                      template: "N",
                      type: "subdesign",
                      item: newData.item === null ? "" : newData.item,
                      subitem_seq: Number(tmpSeq) + 1,
                      orginaltargetdate:
                        newData.orginaltargetdate === null
                          ? ""
                          : newData.orginaltargetdate,
                      revisedtargetdate:
                        newData.revisedtargetdate === null
                          ? ""
                          : newData.revisedtargetdate,
                      actualdate:
                        newData.actualdate === null ? "" : newData.actualdate,
                      remarks: newData.remarks,
                    };
                    let index = dpsDetails.findIndex(
                      (obj) =>
                        obj.subitem_seq == tmpSeq &&
                        obj.dps_design_seq == tmpDesignSeq &&
                        obj.dps_sub_design_seq !== null
                    );
                    example.splice(index + 1, 0, exampleData);
                    example = _.union(
                      example
                        .filter(
                          (obj) =>
                            obj.dps_design_seq == tmpDesignSeq &&
                            obj.dps_sub_design_seq !== null &&
                            (Number(obj.subitem_seq) <= tmpSeq ||
                              obj.flag === "NEW")
                        )
                        .map((jobj) => {
                          return {
                            dps_seq: jobj.dps_seq,
                            dps_design_seq: jobj.dps_design_seq,
                            dps_sub_design_seq: jobj.dps_sub_design_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.subitem_seq),

                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.type,
                          };
                        }),
                      example
                        .filter(
                          (obj) =>
                            Number(obj.subitem_seq) > tmpSeq &&
                            obj.flag !== "NEW" &&
                            obj.dps_design_seq == tmpDesignSeq &&
                            obj.dps_sub_design_seq !== null
                        )
                        .map((jobj) => {
                          return {
                            dps_seq: jobj.dps_seq,
                            dps_design_seq: jobj.dps_design_seq,
                            dps_sub_design_seq: jobj.dps_sub_design_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.subitem_seq) + 1,

                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.type,
                          };
                        })
                    );
                  }
                  let insertBody = {
                    dps_design_seq: tmpDesignSeq,
                    details: example,
                  };

                  await addDeisgnPackageByRef(tmpType, insertBody).then(
                    (res) => {
                      setTmpSeq(null);
                      setTmpType(null);
                      setTmpDesignSeq(null);
                      setAddFlag(!addFlag);
                    }
                  );

                  resolve();
                });
              }, 1000),
          }}
          components={{
            Action: (props) => {
              //If isn't the add action
              if (
                typeof props.action === typeof Function ||
                props.action.tooltip !== "Add"
              ) {
                return <MTableAction {...props} />;
              } else {
                return (
                  <div
                    ref={addActionRef}
                    onClick={(event) => props.action.onClick(event, props.data)}
                  />
                );
              }
            },
          }}
          localization={{
            header: {
              actions: "",
            },
          }}
          options={{
            exportButton: true,
            paging: false,
            search: false,
            showTitle: false,
            padding: "dense",
          }}
        />
      )}
    </Fragment>
  );
};

export default DPS;
